'use strict'

export default function helpers() {

  /**
   * @description Call Element.prototype.bindEvent on each element of the HTMLCollection
   * @param {string, string, function || string, function} params type of event
   * @returns {undefined}
   */
  HTMLCollection.prototype.bindEvent = function (...params) {
    Array.prototype.forEach.call(this, (element) => {
      element.bindEvent(...params)
    })
  }

  /**
   * @description Call Element.prototype.bindEvent on each element of the NodeList
   * @param {string, string, function || string, function} params type of event
   * @returns {undefined}
   */
  NodeList.prototype.bindEvent = function (...params) {
    this.forEach(element => {
      element.bindEvent(...params)
    })
  }
  
  /**
   * @description add an event listener and check for event delegation
   * @param {string} event type of event
   * @param {string|function} arg2 selector or function
   * @param {function} arg3 only if arg2 is used as a string
   * @returns {undefined} none
   */
  Element.prototype.bindEvent = function (event, arg2, arg3) {
    let selector = null
    let fn = null
    
    if (typeof arg2 === 'string') {
      selector = arg2
      fn = arg3
    } else {
      fn = arg2
    }
    
    this.addEventListener(event, e => {
      if (selector && e.isTarget(selector) || !selector) {
        fn(e)
      }
    })
  }
  
  /**
   * @description return top and left position of an element
   * @returns {object} {top,left}
   */
  Element.prototype.offset = function () {
    let rect = this.getBoundingClientRect()
    let bodyElt = document.body
    
    return {
      top: rect.top + bodyElt.scrollTop,
      left: rect.left + bodyElt.scrollLeft
    }
  }
  
  /**
   * @description loop on element siblings to find the index
   * @returns {number} index of the element
   */
  Element.prototype.index = function () {
    let num = 0
    const children = [...this.parentElement.children]
  
    children.some(child => {
      const isElt = child === this
      if (!isElt) {
        num++
      }
      return isElt
    })
    return num
  }
  
  /**
   * @description loop through ancestors of event.target to check for the delegated element
   * @param {string} selector css selector
   * @returns {boolean} if selector has been found
   */
  Event.prototype.isTarget = function (selector) {
    let element = this.target
    while (element && element !== this.currentTarget) {
      if (!element.matches(selector)) {
        element = element.parentElement
      } else {
        this.customCurrentTarget = element
        return true
      }
    }
    return false
  }
  
  /**
   * @description remove polyfill
   * @returns {undefined}
   */
  if (!Element.prototype.remove) {
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this)
      }
    }
  }
  
  /**
   * @description forEach polyfill from MDN
   * https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
   * @param {function} callback function
   * @param {object} thisArg object
   * @returns {undefined}
   */
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg = window) {
      for (let i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/utils/helpers.js